module.exports = __webpack_public_path__ + "static/media/header.a670077f.png";